export const STATUS_CODE = {
    SUCCESS_CODE : 2000
}